export default __webpack_public_path__ + "static/media/checked.9385c95d.png";